var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a6aeb2c1-22de-4135-85f3-49e473c7638c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-59ee7fd4-3069-45ea-980e-ea231e28ef13 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-59ee7fd4-3069-45ea-980e-ea231e28ef13",
    d: "M21.99,21.98h-11.97c-.36,0-.69-.19-.87-.5s-.18-.69,0-1l5.99-10.37c.36-.62,1.38-.62,1.73,0l5.99,10.37c.18.31.18.69,0,1s-.51.5-.87.5ZM11.75,19.98h8.51l-4.25-7.37-4.25,7.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-59ee7fd4-3069-45ea-980e-ea231e28ef13",
    d: "M16,17.49c-.41,0-.75-.34-.75-.75v-1.13c0-.41.34-.75.75-.75s.75.34.75.75v1.13c0,.41-.34.75-.75.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-59ee7fd4-3069-45ea-980e-ea231e28ef13",
    cx: 16,
    cy: 18.7,
    r: 0.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.574481f5704e4fe8bacf5a46cec5b606.svg";
export { ForwardRef as ReactComponent };